module.exports = __webpack_public_path__ + "img/logo-full.34894776.png";